var _a;
import { createSlice } from "@reduxjs/toolkit";
import { getFromLocalStorage } from "module/common/utils";
import { fetchUserInfo, callPostAuthLogin, callPostAuthRegister, callPostAuthVerify, } from "./thunk";
export var authTokenKey = "access";
export var initialState = {
    isAuthenticated: !!getFromLocalStorage(authTokenKey, false),
    loginStatus: "idle",
    fetchStatus: "idle",
    registerStatus: "idle",
    verifyStatus: "idle",
    // TODO: Move to separate Reducer
    apiKeys: null,
    errorMessage: null,
    refreshToken: "",
};
var authReducer = createSlice({
    name: "auth",
    initialState: initialState,
    reducers: {
        setIsAuthenticated: function (state, _a) {
            var payload = _a.payload;
            state.isAuthenticated = payload;
        },
        setUserInfo: function (state, _a) {
            var payload = _a.payload;
            state.userInfo = payload;
        },
        setApiKeys: function (state, _a) {
            var payload = _a.payload;
            state.apiKeys = payload;
        },
        setSubscription: function (state, _a) {
            var payload = _a.payload;
            state.subscription = payload;
        },
        setResetAuthErrorMessage: function (state) {
            state.errorMessage = null;
        },
        setPlans: function (state, _a) {
            var payload = _a.payload;
            state.plans = payload;
        },
        setAddOns: function (state, _a) {
            var payload = _a.payload;
            state.addOns = payload;
        },
        setUsageBlockOptions: function (state, _a) {
            var payload = _a.payload;
            state.usageBlockOptions = payload;
        },
    },
    extraReducers: function (builder) {
        builder.addCase(callPostAuthLogin.pending, function (state) {
            state.loginStatus = "loading";
        });
        builder.addCase(callPostAuthLogin.fulfilled, function (state, _a) {
            var payload = _a.payload;
            state.isAuthenticated = !!payload;
            state.loginStatus = "success";
        });
        builder.addCase(callPostAuthLogin.rejected, function (state, action) {
            state.loginStatus = "failed";
            state.errorMessage = "".concat(action.payload) || action.error.message;
        });
        builder.addCase(callPostAuthRegister.pending, function (state) {
            state.registerStatus = "loading";
        });
        builder.addCase(callPostAuthRegister.fulfilled, function (state) {
            state.registerStatus = "success";
        });
        builder.addCase(callPostAuthRegister.rejected, function (state, action) {
            state.registerStatus = "failed";
            state.errorMessage = "".concat(action.payload) || action.error.message;
        });
        builder.addCase(callPostAuthVerify.pending, function (state) {
            state.verifyStatus = "loading";
        });
        builder.addCase(callPostAuthVerify.fulfilled, function (state, _a) {
            var payload = _a.payload;
            state.isAuthenticated = !!payload;
            state.verifyStatus = "success";
        });
        builder.addCase(callPostAuthVerify.rejected, function (state, action) {
            state.verifyStatus = "failed";
            state.errorMessage = "".concat(action.payload) || action.error.message;
        });
        builder.addCase(fetchUserInfo.pending, function (state) {
            state.fetchStatus = "loading";
        });
        builder.addCase(fetchUserInfo.fulfilled, function (state, _a) {
            var payload = _a.payload;
            state.userInfo = payload;
            state.fetchStatus = "success";
        });
        builder.addCase(fetchUserInfo.rejected, function (state, action) {
            state.fetchStatus = "failed";
            state.errorMessage = action.error.message;
        });
    },
});
export var setIsAuthenticated = (_a = authReducer.actions, _a.setIsAuthenticated), setUserInfo = _a.setUserInfo, setApiKeys = _a.setApiKeys, setResetAuthErrorMessage = _a.setResetAuthErrorMessage, setSubscription = _a.setSubscription, setPlans = _a.setPlans, setAddOns = _a.setAddOns, setUsageBlockOptions = _a.setUsageBlockOptions;
export default authReducer.reducer;
